/**
 * Country flag emoji from an ISO-3166 alpha-2 code; the neutral globe when unknown or hidden.
 *
 * This mirrors `flagEmoji` in `@townsy/domain`. The domain package imports `node:crypto` for
 * other helpers, so it cannot be bundled for the browser; the two implementations are kept
 * byte-for-byte identical and covered by a unit test here.
 */
export function flagEmoji(countryCode: string | null | undefined): string {
  if (!countryCode || !/^[A-Z]{2}$/.test(countryCode)) return "\u{1F310}";
  const base = 0x1f1e6;
  return String.fromCodePoint(base + countryCode.charCodeAt(0) - 65, base + countryCode.charCodeAt(1) - 65);
}

/** Accessible description for the flag (screen readers should not read two regional indicator symbols). */
export function flagLabel(countryCode: string | null | undefined): string {
  if (!countryCode || !/^[A-Z]{2}$/.test(countryCode)) return "country unknown";
  try {
    const names = new Intl.DisplayNames(["en"], { type: "region" });
    return names.of(countryCode) ?? countryCode;
  } catch {
    return countryCode;
  }
}
